import { Anchor, Container, Flex, Title } from "@mantine/core";
import { Link } from "react-router";

export function NotFound() {
	return (
		<Container h="100%" p="lg">
			<Flex align="center" justify="center" direction="column" gap="md">
				<Title order={3}>Page Not Found</Title>
				<Anchor component={Link} to="/" size="xl">
					Go to home
				</Anchor>
			</Flex>
		</Container>
	);
}
